import { activityGapSummary } from "./activityGap";
import { diaperCheckSummary } from "./diaperCheck";
import type { CareAlertCategory } from "./workflow";

type SummaryFn = typeof diaperCheckSummary;

/** The inbox and board summary line per care-alert kind. */
export const CARE_ALERT_SUMMARY: Record<CareAlertCategory, SummaryFn> = {
  diaper_check_overdue: diaperCheckSummary,
  activity_gap: activityGapSummary,
};
